/**
 * User API endpoints
 */

import apiClient from '../apiClient';
import { ApiResponse } from '@/types/api.types';
import { User, UserPreferences } from '@/types/store.types';

/**
 * Get user profile
 */
export const getUserProfile = async (): Promise<User> => {
  const response = await apiClient.get<ApiResponse<User>>('/user/profile');
  return response.data;
};

/**
 * Update user profile
 */
export const updateUserProfile = async (data: Partial<User>): Promise<User> => {
  const response = await apiClient.put<ApiResponse<User>>(
    '/user/profile',
    data
  );
  return response.data;
};

/**
 * Get user preferences
 */
export const getUserPreferences = async (): Promise<UserPreferences> => {
  const response = await apiClient.get<ApiResponse<UserPreferences>>(
    '/user/preferences'
  );
  return response.data;
};

/**
 * Update user preferences
 */
export const updateUserPreferences = async (
  data: Partial<UserPreferences>
): Promise<UserPreferences> => {
  const response = await apiClient.put<ApiResponse<UserPreferences>>(
    '/user/preferences',
    data
  );
  return response.data;
};

/**
 * Upload user avatar
 */
export const uploadAvatar = async (
  file: File,
  onProgress?: (progress: number) => void
): Promise<string> => {
  const formData = new FormData();
  formData.append('avatar', file);

  const response = await apiClient.upload<ApiResponse<{ url: string }>>(
    '/user/avatar',
    formData,
    (progressEvent) => {
      if (onProgress && progressEvent.total) {
        const progress = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        onProgress(progress);
      }
    }
  );

  return response.data.url;
};

/**
 * Delete user account
 */
export const deleteUserAccount = async (): Promise<void> => {
  await apiClient.delete('/user/account');
};
